const ROUTES = {
  DASHBOARD: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  TEACHER_CLASSES: "/teacher-dashboard/classes",
  TEACHER_CLASS_DETAIL: "/teacher-dashboard/class-subjects/:classSubjectId",
  TEACHER_ASSIGNMENTS: "/assignment-management/manage",
  EXAM_DEFINITION: "/exam-management/definition",
  TEACHER_ACTIVE_TESTS: "/exam-management/manage",
  CLASS_BEHAVIOR: "/class-management/behavior",
  CLASS_REPORT_CARD: "/class-management/report-card",
  CLASS_STUDENTS: "/class-management/students",
  CLASS_LEVELING: "/class-management/leveling",
  CLASS_ATTENDANCE: "/class-management/attendance",
  TEACHER_SCHOOL_NOTIFICATIONS: "/teacher-dashboard/school-notifications",
  TEACHER_WEEKLY_SCHEDULE: "/teacher-dashboard/weekly-schedule",
  ASSIGNMENT_DEFINITION: "/assignment-management/definition",
  CHALLENGE_DEFINITION: "/challenge-management/definition",
  TEACHER_CHALLENGES: "/challenge-management/manage",
  AI_EXAM_GENERATION: "/ai-assistant/exam-generation",
  AI_ASSIGNMENT_GENERATION: "/ai-assistant/assignment-generation",
  AI_IMAGE_GENERATION: "/ai-assistant/image-generation",
  AI_LESSON_PLAN_GENERATION: "/ai-assistant/lesson-plan-generation",
  AI_LESSON_SUMMARY: "/ai-assistant/lesson-summary",
  CONTENT_MANAGEMENT: "/content-management/manage",
};

export default ROUTES;
